module.exports = __webpack_public_path__ + "img/accenture.15180ed2.svg";